import React, {PropTypes} from 'react';
import {I18n} from 'react-redux-i18n';

import AfricanGreyImage from '../../../images/paracheirodon_innesi.jpg';

const StyledLabel2ColLrg = ({
  logoUrl,
	styleElements
}) => {
  // Create the element styles
	const headerBackground = {background: styleElements.headerBgColor};
	const headerFont = {color: styleElements.headerFontColor};
	const detailBackground = {backgroundColor: styleElements.detailBgColor};
	const detailFont = {color: styleElements.detailFontColor};
  const valueBackground = {backgroundColor: styleElements.valueBgColor};
  const valueFont = {color: styleElements.valueFontColor};
  const priceBackground = {backgroundColor: styleElements.priceBgColor};
  const priceFont = {color: styleElements.priceFontColor};
  const labelBackground = {background: styleElements.labelBgColor};
  const tableBackground = {borderColor: styleElements.labelBgColor};
  const labelBorder = {borderColor: styleElements.labelBorderColor};

  return (
		<div className="two-col-lrg label-main" style={labelBorder}>
      <div className="label-title" style={headerBackground}>
        <span className="label-control form-control" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_LAT_NAME')}</span>
        <span className="label-control form-control latin-name" style={headerFont}>{I18n.t('CUSTOM_LABEL_PET_NAME')}</span>
      </div>
        <div className="label-content" style={labelBackground}>
          <div className="label-footer">
             <img src={AfricanGreyImage} className="float-left" />
            <div className="label-info-left-col" style={priceBackground}>
              <span className="label-control form-control float-left txt-price" style={priceFont}>{I18n.t('CUSTOM_LABEL_PET_PRICE')}</span>
              <div className="label-logo">
                <img src={logoUrl}  />
              </div>
              <div className="barcode-customize barcode float-right"/>
            </div> 
          </div>    
          <table className="float-left" cellPadding="0" cellSpacing="0">
            <tbody>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_7')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_7')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_8')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_8')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_9')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_9')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_1')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_1')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_4')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_4')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_3')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_3')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_11')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_11')}</span></td>
              </tr>
               <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_12')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_12')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_14')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_14')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_5')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_5')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_17')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_17')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_16')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_16')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_18')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_18')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_6')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_6')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_13')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_13')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('CUSTOM_LABEL_KEY_19')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>{I18n.t('CUSTOM_LABEL_VALUE_19')}</span></td>
              </tr>
              <tr style={tableBackground}>
                <td className="category" style={detailBackground}><span className="label-control form-control" style={detailFont}>{I18n.t('PLU')}</span></td>
                <td className="info" style={valueBackground}><span className="label-control form-control" style={valueFont}>12345</span></td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
	);
};

StyledLabel2ColLrg.propTypes = {
	logoUrl: PropTypes.string.isRequired,
  styleElements: PropTypes.object.isRequired
};

export default StyledLabel2ColLrg;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/StyledLabel2ColLrg.js
 **/